import styled from 'styled-components';

import { Colors } from '../utils/style-utils';

export const Separator = styled.hr`
  border-color: ${Colors.Blue500};
  opacity: 0.25;
`;
